import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { AuthRoles, readableSchemeTypes, Roles, SchemeTypes } from 'config';
import { Control, useForm, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppSelect,
  AppTextField,
  AppSwitch,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import * as ReimbursementsListSelectors from 'redux/reducers/reimbursements_list_reducer/selectors';

interface FormFields {
  vat_num: string | null;
  schemeType: string | null;
  isPending: boolean | null;
}

interface IProps {
  vat_number: string | null;
  schemeType: string | null;
  isPending: boolean | null;
  role: Roles;
}

const FilterForm = (props: IProps) => {
  const history = useHistory();

  const defaultValues = {
    vat_num: props.vat_number ? props.vat_number : null,
    schemeType: props.schemeType ? props.schemeType : null,
    isPending: props.isPending ? props.isPending : false,
  };
  const { control, errors, handleSubmit, reset } = useForm<FormFields>({
    defaultValues: defaultValues,
  });

  const onSubmit = (data: any) => {
    let query = [];
    if (data.vat_num)
      query.push({
        key: 'vat_num',
        value: data.vat_num,
      });
    if (data.schemeType)
      query.push({
        key: 'schemeType',
        value: data.schemeType,
      });
    if (data.isPending)
      query.push({
        key: 'isPending',
        value: data.isPending,
      });
    let queryString = '';
    query.map((query, index) => {
      if (index == 0) queryString += `?${query.key}=${query.value}`;
      else queryString += `&${query.key}=${query.value}`;
    });
    history.push(NavigationConfig.reimbursementsPage().path + queryString);
  };

  const clearFilter = () => {
    history.push(NavigationConfig.reimbursementsPage().path);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '0.6rem' }}>
      <GridLayout
        elements={
          [
            {
              element: renderVatNumberField(errors, control),
              size: 3,
              id: 'vatNumber',
            },
            {
              element: renderSchemeTypeField(errors, control),
              size: 3,
              id: 'schemeType',
            },
            {
              element: renderIsPendingField(errors, control),
              size: 3,
              id: 'isPending',
            },
            // {
            //   element: <span></span>,
            //   size: 1,
            //   id: 'space',
            // },
            {
              element: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginRight: '0.25rem',
                    }}
                  >
                    <TranslatedText textMap={Translations.search} />
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginLeft: '0.25rem',
                    }}
                    onClick={clearFilter}
                  >
                    <TranslatedText textMap={Translations.clear} />
                  </Button>
                </div>
              ),
              size: 3,
              id: 'search',
            },
          ] as any
        }
      />
    </form>
  );
};

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      fullWidth
      id="vat_num"
      label={<TranslatedText textMap={Translations.vat_number} />}
      error={'vat_num' in errors}
      name="vat_num"
      control={control}
      rules={{}}
      helperText={errors.vat_num && errors.vat_num.message}
    />
  );
};

const renderSchemeTypeField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const schemeTypes = ['MOSS', 'VOES', 'IMPORT'];
  let select_options = [];
  select_options.push({
    id: '',
    label: Translations.schemeType.English,
  });
  for (let schemeType of schemeTypes) {
    select_options.push({
      id: schemeType,
      label: _.get(readableSchemeTypes, schemeType),
    });
  }
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.schemeType} />}
      id="schemeType"
      name="schemeType"
      error={'schemeType' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.schemeType && errors.schemeType.message}
    />
  );
};

const renderIsPendingField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '0.6rem',
      }}
    >
      <Typography>
        <TranslatedText
          textMap={Translations.showAll}
          defaultText={Translations.showAll.English}
        />
      </Typography>
      <AppSwitch
        color="primary"
        style={{ color: 'black' }}
        id="isPending"
        name="isPending"
        control={control}
        rules={{}}
      />
      <Typography>
        <TranslatedText
          textMap={Translations.showPending}
          defaultText={Translations.showPending.English}
        />
      </Typography>
    </div>
  );
};

export default FilterForm;
